import { fromJS } from "immutable";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import config from "../../config/app.json";
import InnerFrameImage from "../../containers/Frame/InnerFrameImage";
import { FRAME_CLASSES, getFrameDropAreaId, getImageSource, isVideo } from "../../helpers/frameHelper";
import { getImageThumbnailURL } from "../../helpers/URLHelper";

const appUrl = config['APPICONS'][config['APPICONS']['current']];

const DroppableContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: pointer;

    * {
        pointer-events: none; // using pointer events so that we can detect mouse up in LibraryComponent
    }
`;

function DroppableAreasComponent(props) {
    const { // from parent
        Id, groupId, isGrouped, clip_id, frameItemData, droppableItemData, socket, totalLength, currIndex,
        isFrameVisible, isSlidePreview, idPrefix
    } = props;
    const { // from store
        libraryImageDrag, isLibraryItemDragging, transformStatus, selectedItem, selectedItemId,
        swapHoverDrop, selectedScene, selectedFrameClip, propertyWindow, isFraming,
        isPlay, isPlayAll,
    } = props;
    const { // dispatch
        updateSwapHoverDrop, frameImageDropped, selectFrameClip, setPropertyWindow, updateTransformStatus,
    } = props;

    const lastMouseUp = useRef(0);
    const canAllowClick = useRef(false);
    const imageRef = useRef();
    const imageContainerRef = useRef();
    const droppableAreaRef = useRef();

    const [showImage, setShowImage] = useState(true);
    const [imageHovered, setImageHovered] = useState(false);
    const [hoveredImageStyles, setHoveredImageStyles] = useState({});
    const [hoverImage, setHoverImage] = useState();

    const isItemMoving = transformStatus.get("moving");


    useEffect(() => {
        if (
            droppableItemData.getIn(["imgDetails", "color"]) !== undefined
            && droppableItemData.getIn(["imgDetails", "color"]) !== ""
            && droppableItemData.getIn(["imgDetails", "src"]) === ""
        ) {
            setShowImage(false);
            // props.onLoadData(currIndex);
        } else { // color picker undo
            setShowImage(true);
        }
    }, [droppableItemData]);

    function getFlipPosition(value) {
        let flip =
            value === 1
                ? " scaleX(-1)"
                : value === 2
                ? " scaleY(-1)"
                : value === 3
                ? " scaleX(-1) scaleY(-1)"
                : "";
        return flip;
    }

    function getStyles() {
        let flipPosition = droppableItemData.getIn(["imgDetails", "flipPosition"])
 
        if (!imageHovered) {
            let imageWidth =
            frameItemData.get("defaultWidth") *
            droppableItemData.getIn(["imgDetails", "original", "width"]);
            let imageHeight =
            frameItemData.get("defaultHeight") *
            droppableItemData.getIn(["imgDetails", "original", "height"]);

            let imageX =
            frameItemData.get("defaultWidth") *
            droppableItemData.getIn(["imgDetails", "original", "x"]);
            let imageY =
            frameItemData.get("defaultHeight") *
            droppableItemData.getIn(["imgDetails", "original", "y"]);
 
            return {
                position: "relative",
                width: `${imageWidth}px`,
                height: `${imageHeight}px`,
                transform: `translate(${imageX}px, ${imageY}px) ${getFlipPosition(flipPosition)}`,
            };
        } else if (imageHovered) {
            const { width, height, X, Y } = hoveredImageStyles;
            return {
                position: "relative",
                width: `${frameItemData.get("defaultWidth") * width}px`,
                height: `${frameItemData.get("defaultHeight") * height}px`,
                transform: `translate(${
                    frameItemData.get("defaultWidth") * X
                }px, ${frameItemData.get("defaultHeight") * Y}px)`,
            };
        }
    }

    function getSource(id) {
        let imageDetails = droppableItemData.getIn(["imgDetails"]);
        let defaultImageSrc = `${appUrl}${imageDetails.getIn(["defaultImageDetails", "src"])}`

        if (imageHovered) {
            imageDetails = hoverImage;
        }

        let { src, thumb } = getImageSource(imageDetails, id);
        if (!imageDetails.get("src") && !imageDetails.get('stickerify') && !imageDetails.get('bgremoval')) {
            return defaultImageSrc;
        } else if (imageHovered) {
            return thumb;
        }
        return src;
    }

    let dropAreaPointerEvents = "auto";

    return (
        <DroppableContainer
            ref={droppableAreaRef}
            style={{
                clipPath: `path('${droppableItemData.get("clipData")}')`,
                backgroundColor: droppableItemData.getIn([
                    "imgDetails",
                    "color",
                ]),
                pointerEvents: dropAreaPointerEvents,
                touchAction: 'none',
            }}
            id={getFrameDropAreaId(Id, clip_id, idPrefix)}
            className={FRAME_CLASSES["DROP_AREA"]}
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            // onPointerDown={handleMouseDown}
            // onPointerUp={handleMouseUp}
            data-tswap-tkn={getFrameDropAreaId(Id, clip_id, idPrefix)}
        >
            <InnerFrameImage
                imageContainerRef={imageContainerRef}
                containerStyles={getStyles()}
                Id={Id}
                clip_id={clip_id}
                droppableItemData={droppableItemData}
                src={getSource(Id)}
                thumb={getImageThumbnailURL(droppableItemData.getIn(["imgDetails", "type"]), droppableItemData.getIn(["imgDetails", "subType"]), droppableItemData.getIn(["imgDetails", "thumb"]) || droppableItemData.getIn(["imgDetails", "thumbnail"]))}
                imageRef={imageRef}
                showImage={showImage || imageHovered}
                onLoadData = {props.onLoadData}
                isImageHovered = {imageHovered}
                currIndex = {props.currIndex}
                idPrefix={idPrefix}
            />
        </DroppableContainer>
    );
}

export default DroppableAreasComponent;


// WEBPACK FOOTER //
// ./src/components/Frame/DroppableAreasComponent.js